import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7895e404"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "page" };
const _hoisted_2 = { class: "card" };
const _hoisted_3 = { class: "card-header" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "divider" }, null, -1));
const _hoisted_5 = { class: "card-body" };
const _hoisted_6 = { class: "section file-section" };
const _hoisted_7 = {
    key: 0,
    class: "error",
    style: { "color": "red" }
};
const _hoisted_8 = {
    key: 0,
    class: "section back-section"
};
const _hoisted_9 = {
    key: 1,
    class: "panel"
};
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", { class: "panel-title" }, "検索結果", -1));
const _hoisted_11 = { class: "table-wrapper" };
const _hoisted_12 = { class: "result-table" };
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", { class: "matchedNum" }, "携帯電話番号"),
        /*#__PURE__*/ _createElementVNode("th", { class: "customerId" }, "顧客ID"),
        /*#__PURE__*/ _createElementVNode("th", { class: "name" }, "氏名")
    ])
], -1));
const _hoisted_14 = { class: "matchedNum" };
const _hoisted_15 = { class: "customerId" };
const _hoisted_16 = { class: "name" };
const _hoisted_17 = { class: "table-footer" };
const _hoisted_18 = ["disabled"];
const _hoisted_19 = { class: "page-indicator" };
const _hoisted_20 = ["disabled"];
const _hoisted_21 = {
    key: 2,
    class: "panel"
};
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", { class: "panel-title" }, "一致しなかったユーザ", -1));
const _hoisted_23 = { class: "table-wrapper" };
const _hoisted_24 = { class: "result-table" };
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", { class: "unmatchedNum" }, "携帯電話番号")
    ])
], -1));
const _hoisted_26 = { class: "unmatchedNum" };
const _hoisted_27 = { class: "table-footer" };
const _hoisted_28 = ["disabled"];
const _hoisted_29 = { class: "page-indicator" };
const _hoisted_30 = ["disabled"];
const _hoisted_31 = {
    key: 3,
    class: "section footer-section"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Title = _resolveComponent("Title");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_Title, {
                    msg: "CSVインポート",
                    submsg: "CSV Import"
                })
            ]),
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("input", {
                        ref: "fileInput",
                        type: "file",
                        accept: ".csv",
                        onChange: _cache[0] || (_cache[0] =
                            //@ts-ignore
                            (...args) => (_ctx.onFileChange && _ctx.onFileChange(...args)))
                    }, null, 544),
                    (_ctx.errorMessage)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.errorMessage), 1))
                        : _createCommentVNode("", true)
                ]),
                (!(_ctx.matched.length > 0 || _ctx.unmatched.length > 0))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("button", {
                            class: "btn-secondary",
                            onClick: _cache[1] || (_cache[1] =
                                //@ts-ignore
                                (...args) => (_ctx.onBack && _ctx.onBack(...args)))
                        }, "戻る")
                    ]))
                    : _createCommentVNode("", true),
                (_ctx.matched.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _hoisted_10,
                        _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("table", _hoisted_12, [
                                _hoisted_13,
                                _createElementVNode("tbody", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pagedMatched, (r, i) => {
                                        return (_openBlock(), _createElementBlock("tr", { key: i }, [
                                            _createElementVNode("td", _hoisted_14, _toDisplayString(r.mobile_phone_number), 1),
                                            _createElementVNode("td", _hoisted_15, _toDisplayString(r.crm_customer_id), 1),
                                            _createElementVNode("td", _hoisted_16, _toDisplayString(r.name), 1)
                                        ]));
                                    }), 128))
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("button", {
                                class: "pg-btn",
                                disabled: _ctx.matchedPage <= 1,
                                onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.setMatchedPage(_ctx.matchedPage - 1)))
                            }, " ‹ ", 8, _hoisted_18),
                            _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.matchedPage) + " / " + _toDisplayString(_ctx.matchedTotalPages), 1),
                            _createElementVNode("button", {
                                class: "pg-btn",
                                disabled: _ctx.matchedPage >= _ctx.matchedTotalPages,
                                onClick: _cache[3] || (_cache[3] = ($event) => (_ctx.setMatchedPage(_ctx.matchedPage + 1)))
                            }, " › ", 8, _hoisted_20)
                        ])
                    ]))
                    : _createCommentVNode("", true),
                (_ctx.unmatched.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _hoisted_22,
                        _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("table", _hoisted_24, [
                                _hoisted_25,
                                _createElementVNode("tbody", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pagedUnmatched, (p, i) => {
                                        return (_openBlock(), _createElementBlock("tr", { key: i }, [
                                            _createElementVNode("td", _hoisted_26, _toDisplayString(p), 1)
                                        ]));
                                    }), 128))
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("button", {
                                class: "pg-btn",
                                disabled: _ctx.unmatchedPage <= 1,
                                onClick: _cache[4] || (_cache[4] = ($event) => (_ctx.setUnmatchedPage(_ctx.unmatchedPage - 1)))
                            }, " ‹ ", 8, _hoisted_28),
                            _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.unmatchedPage) + " / " + _toDisplayString(_ctx.unmatchedTotalPages), 1),
                            _createElementVNode("button", {
                                class: "pg-btn",
                                disabled: _ctx.unmatchedPage >= _ctx.unmatchedTotalPages,
                                onClick: _cache[5] || (_cache[5] = ($event) => (_ctx.setUnmatchedPage(_ctx.unmatchedPage + 1)))
                            }, " › ", 8, _hoisted_30)
                        ])
                    ]))
                    : _createCommentVNode("", true),
                (_ctx.matched.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        _createElementVNode("button", {
                            class: "btn-primary",
                            onClick: _cache[6] || (_cache[6] =
                                //@ts-ignore
                                (...args) => (_ctx.goNext && _ctx.goNext(...args)))
                        }, " 付与対象選択へ戻る ")
                    ]))
                    : _createCommentVNode("", true)
            ])
        ])
    ]));
}
